import axios from "axios";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import { URL, getAuthorizationHeader } from "../../constans/constants";

const WEB_TOKEN_KEY = "firebaseWebToken";

let messagingInstance = null;

async function fetchWebConfig() {
  const { data } = await axios.get(
    `${URL}api/notify/web/firebase-config`,
    getAuthorizationHeader()
  );
  return data;
}

export async function registerWebPush(username, idEmpresa) {
  if (!("serviceWorker" in navigator) || !("Notification" in window)) {
    console.warn("[FirebaseWebPush] Navegador sin soporte para service worker/notificaciones.");
    return null;
  }
  if (!(await isSupported())) {
    console.warn("[FirebaseWebPush] Firebase Messaging no soportado en este navegador/contexto (¿HTTPS o localhost?).");
    return null;
  }

  const config = await fetchWebConfig();
  const vapidKey = config?.vapidKey?.trim();
  const apiKey = config?.apiKey?.trim();
  if (!apiKey || !vapidKey) {
    const algunCampoCargado = config && Object.values(config).some((v) => v);
    if (algunCampoCargado) {
      // Hay algunos campos pero no todos: probablemente una config a medio cargar.
      console.warn("[FirebaseWebPush] Config de Firebase incompleta.", config);
    }
    // Sin ningún campo cargado: este cliente no tiene push web habilitado, es un estado válido.
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.warn("[FirebaseWebPush] Permiso de notificaciones no otorgado:", permission);
    return null;
  }

  const registration = await navigator.serviceWorker.register(`${URL}firebase-messaging-sw.js`);

  const app = initializeApp({
    apiKey,
    authDomain: config.authDomain,
    projectId: config.projectId,
    messagingSenderId: config.messagingSenderId,
    appId: config.appId,
  });
  messagingInstance = getMessaging(app);

  const token = await getToken(messagingInstance, {
    vapidKey,
    serviceWorkerRegistration: registration,
  });
  if (!token) {
    console.warn("[FirebaseWebPush] getToken() no devolvió token.");
    return null;
  }

  if (localStorage.getItem(WEB_TOKEN_KEY) === token) return token;

  await axios.post(
    `${URL}api/notify/mobile/register-client`,
    {
      username,
      idEmpresa,
      token,
      platform: "web",
      deviceName: navigator.userAgent,
    },
    getAuthorizationHeader()
  );

  localStorage.setItem(WEB_TOKEN_KEY, token);
  return token;
}

/** Suscribe a mensajes recibidos con la app en foreground. Devuelve una función para desuscribirse. */
export function onForegroundMessage(callback) {
  if (!messagingInstance) return () => {};
  return onMessage(messagingInstance, callback);
}
